import {useCallback, useLayoutEffect, useRef} from "react";

export function useEventCallback<T extends (...args: any[]) => void>(
    fn: T,
) {
    const ref = useRef<T>((() => {
        throw new Error('Cannot call an event handler while rendering.')
    }) as any);

    useLayoutEffect(() => {
        ref.current = fn;
    }, [fn]);

    return useCallback(
        (...args: any) =>
            ref.current(...args),
        [],
    ) as T;
}
